import React, { useMemo } from 'react';
import CensusStatistics from 'components/common/census/census-review/CensusStatistics';
import { observer } from 'mobx-react-lite';
import PageHeader from 'components/common/census/census-review/PageHeader';
import CensusStatisticsInitiateAddEePageStore, {
  CensusStatisticsInitiateAddEePageStoreContext,
  useCensusStatisticsInitiateAddEePageStore,
} from 'store/pages/rfq/census-stats-initiate-add-employees/pageStore';
import useGroupQuoteUrlParams from 'global/hooks/useGroupQuoteUrlParams';
import { NarrowPageWrapperStyled } from '../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const pageStore = useCensusStatisticsInitiateAddEePageStore();
  return (
    <>
      <PageHeader pageStore={pageStore} />
      <CensusStatistics pageStore={pageStore} />
    </>
  );
});

const CensusInitiateAddEeReviewPage: React.FC = () => {
  const { periodId, groupId, cartId } = useGroupQuoteUrlParams();
  const pageStore = useMemo(
    () => new CensusStatisticsInitiateAddEePageStore({ enrollmentPeriodId: periodId, groupId, cartId }),
    [],
  );

  return (
    <CensusStatisticsInitiateAddEePageStoreContext.Provider value={pageStore}>
      <NarrowPageWrapperStyled>
        <PageContent />
      </NarrowPageWrapperStyled>
    </CensusStatisticsInitiateAddEePageStoreContext.Provider>
  );
};

export default CensusInitiateAddEeReviewPage;
